<template>
    <div>

        <div v-if="this.value">


            <div v-if="this.value" class="cartmenu cartbox">
                <ul v-if="cart.cart.data">
                    <!-- f={{ floatingPrecision }} -->
                    <!-- {{ cart }} -->
                    <li class="cartdata" v-for="product in cart.cart.data">
                        <!-- {{ product }} -->
                        <div class="product-name">
                            {{ product.product_name }}
                        </div>
                        <div class="product-price">
                            {{ parseFloat(product.price_plus_vat * product.qty).toFixed(floatingPrecision) }} {{ product.currency}}

                        </div>
                        <div class="packaging-qty">
                            {{ product.packaging_qty }} {{ product.packaging_qty_unit }}
                        </div>
                        <div class="cart-element">

                            <roastopus-cart-element-small :product="product" :key="product.product_id"></roastopus-cart-element-small>
                        </div>
                    </li>
                    <li class="cartdata" v-if="cart.products_total_price_plus_vat == 0">
                        {{ __('__JSON__.A kosár üres') }}
                    </li>
                    <li class="last">

                        <div class="total_price">
                            {{ parseFloat(cart.products_total_price_plus_vat).toFixed(floatingPrecision)  }} {{  cart.currency }}
                        </div>
                            <div class="checkout" v-if="!cartmenu_loading && cart.products_total_price_plus_vat > 0">
                            <a class="btn btn-checkout float-end" :href="route">  {{ __('__JSON__.Pénztár') }}  </a>
                        </div>
                            <div class="checkout" v-if="!cartmenu_loading && cart.products_total_price_plus_vat == 0">
                            <a class="float-end btn btn-checkout btn-disabled disabled" :href="route">  {{ __('__JSON__.Pénztár') }}  </a>
                        </div>
                        <div class="checkout" v-if="cartmenu_loading">
                            <a class="float-end btn btn-checkout btn-loading disabled" :href="route"><i class="fas fa-spinner fa-spin"></i>  {{ __('__JSON__.Kosárművelet') }}   </a>
                        </div>
                    </li>
                </ul>

                <div v-if="!cart.cart.data">
                    {{ __('__JSON__.A kosár üres') }}
                </div>
            </div>
        </div>

    </div>
</template>
<script>

import Vue from 'vue';
import { EventBus } from '../../eventbus.js';

import mixin from '../../mixin.js'
export default {
    mixins: [mixin],
    props: ['value', 'cart', 'route', 'cartmenu_loading'],
    data () {
        return {
            menu_visible: this.value,

        }
    },
    methods: {
        // outsideClickCartMenuClose() {
        //     console.log('outsideClickCartMenuClose()');
        //     this.menu_visible = false;
        //     this.$emit('input', this.menu_visible)
        // },
        close() {

            console.log('click close');
            this.menu_visible = false;
            this.$emit('input', this.menu_visible)
        },
        reload() {
            console.log('reload');
            this.$forceUpdate();
        },
        // toggle() {

        //     console.log('toggle cartmenu');
        //     this.menu_visible = !this.menu_visible ;
        //     this.$emit('input', this.menu_visible);
        //     if (this.nenu_visible) {
        //         this.$root.loadCart();

        //     }

        // }
    },
    mounted() {
          EventBus.$on('cart-updated', (newCart) => {
            this.cart = newCart;
        });
        // console.log('CartMenu(cartbox) Component mounted.');
        // console.log('cartmenu_visible='+ this.value);
        // console.info('this.cart:');
        // console.info(this.cart );
        // console.warn('this.$root.cart');
        // console.warn(this.$root.cart );
    }
}
</script>
<style lang="css">
.img-hover {
    cursor: pointer;
}

</style>
